import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Home",
  "use": "Home-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"Home\"><path fill-rule=\"evenodd\" d=\"M.5 6.97L10 .023l9.5 6.947v12.808H.5V6.97zm2.036 1.037v9.748h14.928V8.007L10 2.719 2.536 8.007z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol